import React from "react"
import { Field, propTypes, reduxForm } from "redux-form"
import { defineMessages } from "react-intl"
import FormGroup from "@material-ui/core/FormGroup"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import SearchIcon from "@material-ui/icons/Search"
import FieldDatePicker from "../../component/forms/FieldDatePicker"
import { ButtonClear, ButtonSubmit } from "../../component/buttons"
import useSmartFormat from "../../i18n/useSmartFormat"
import FieldTextarea from "../../component/forms/FieldTextarea"
import { words } from "../../i18n/lstrings"

export const StatementSearchFormName = "StatementSearchForm"

const messages = defineMessages({
  search: {
    id: "word.search",
    defaultMessage: "Search"
  },
  from: {
    id: "word.from",
    defaultMessage: "From"
  },
  to: {
    id: "word.to",
    defaultMessage: "To"
  }
})

function StatementSearchForm({
  handleSubmit,
  pristine,
  submitting,
  invalid,
  reset,
  onSubmit
}) {
  const format = useSmartFormat()

  return (
    <Box p={2} w="400">
      <Typography gutterBottom variant="h6">
        {format(messages.search)}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <Box display="flex" gridGap={8}>
            <Field
              component={FieldDatePicker}
              id="from"
              placeholder={format(messages.from)}
              name="fromDate"
            />
            <Field
              component={FieldDatePicker}
              id="to"
              name="toDate"
              placeholder={format(messages.to)}
            />
          </Box>

          <Field
            component={FieldTextarea}
            label={format(words.type)}
            name="type"
            placeholder={format(words.type)}
            type="text"
          />
          <Field
            component={FieldTextarea}
            label={format(words.name)}
            name="namePattern"
            placeholder={format(words.name)}
            type="text"
          />
          <Field
            component={FieldTextarea}
            label={format(words.jumpId)}
            name="jumpIdPortfolio"
            placeholder={format(words.jumpId)}
            type="text"
          />
        </FormGroup>
        <Box mt={2} gridGap={8} display="flex" justifyContent="flex-end">
          <ButtonClear disabled={pristine || submitting} onClick={reset} />
          <ButtonSubmit
            startIcon={<SearchIcon />}
            disabled={invalid || submitting}
            text={words.search}
          />
        </Box>
      </form>
    </Box>
  )
}

// TODO : implementer une validation
function validate(/* values */) {
  return {}
}

StatementSearchForm.propTypes = {
  ...propTypes
}

export default reduxForm({
  form: StatementSearchFormName,
  destroyOnUnmount: false,
  validate
})(StatementSearchForm)
